import { render } from "./Check.vue?vue&type=template&id=3c5ce9e0"
import script from "./Check.vue?vue&type=script&lang=js"
export * from "./Check.vue?vue&type=script&lang=js"

import "./Check.vue?vue&type=style&index=0&id=3c5ce9e0&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__